export type Dimensions = {
  width?: string | null;
  height?: string | null;
  length?: string | null;
  operatingWeight?: string | null;
  maximalLoadCapacity?: string | null;
  wheelBase?: string | null;
};
